<template>
	<div @click="navigate(data)" class="col-md-3 col-xs-6 p-3 highlight zoomdiv text-center">
		<img :src="require(`../assets/thumbs/${data.iconSrc}`)" class="img-fluid rounded"/>
		<h5 class="mt-2 text-capitalize">{{data.gameName}}</h5>
	</div>
</template>

<script>
export default {
  name: "gameitem",
  props: ["data"],
  data() {
    return {};
  },
  methods: {
    navigate(gamedata) {
	//   sessionStorage.setItem("gameData", JSON.stringify(this.data));
      this.$router.push({
        name: "detail",
        params: {
          gamename: gamedata.gameName.split(" ").join("-"),
          data: gamedata
        }
      });
    }
  }
};
</script>

<style scoped>
img {
  border: 2px solid rgb(58, 69, 104);
	min-width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/GameItem.vue